import React from 'react';
import { Navigate } from 'react-router-dom';
import facilities from './config/facilities.json';

import FacilityFrontPage from './views/FacilityFrontPage/FacilityFrontPage';
import Home from './views/Home/Home';
import StaffGallery from './views/StaffGallery/StaffGallery';
import Login from './views/Login/Login';
import DeviceManager from './views/DeviceManager/DeviceManager';
import AccountManager from './views/AccountManager/AccountManager';
import ImageSubmission from './views/ImageSubmission/ImageSubmission';
import ProtectedRoute from './guards/ProtectedRoute';
import AccountSettings from './views/AccountSettings/AccountSettings';
import SlideShow from './views/SlideShow/SlideShow';
import Calendar from './views/Calendar/Calendar';
import SignageCalendar from './views/SignageCalendar/SignageCalendar';
import Scheduler from './views/Scheduler/Scheduler';
import Verify from './views/Verify/Verify';
import SignageScheduler from './views/SignageScheduler/SignageScheduler';
import Groups from './views/groups/Groups';
import CalenbdarEditor from './views/CalendarEditor/CalendarEditor';
import RoomManager from './views/RoomManager/RoomManager';
import SignageEditor from './views/SignageEditor/SignageEditor';
import SignagePlayList from './views/SignagePlayList/SignagePlayList';
import Testimonials from './views/Testimonials/Testimonials';
import CorporateMenu from './views/CorporateMenu/CorporateMenu';

const facilityRoutes = facilities.flatMap((facility) => [
  {
    path: `/${facility.id}`,
    element: () => (
      <FacilityFrontPage
        facilityName={facility.name}
        facilityLogo={facility.logo}
        facilityId={facility.id}
      />
    ),
  },
]);

const routes = [
  {
    path: '/',
    element: <Navigate to="/submit" />,
  },
  {
    path: '/login',
    element: <Login />,
  },
  {
    path: '/home',
    element: <Home />,
  },
  {
    path: '/verify',
    element: <Verify />,
  },
  {
    path: '/slideshow',
    element: <SlideShow />,
  },
  {
    path: `/devices`,
    element: (
      <ProtectedRoute userForbidden={true}>
        <DeviceManager />
      </ProtectedRoute>
    ),
  },
  {
    path: `/accounts`,
    element: (
      <ProtectedRoute userForbidden={true}>
        <AccountManager />
      </ProtectedRoute>
    ),
  },
  {
    path: `/gallery`,
    element: (
      <ProtectedRoute userForbidden={false}>
        <StaffGallery />
      </ProtectedRoute>
    ),
  },
  {
    path: `/submit`,
    element: (
      <ProtectedRoute userForbidden={false}>
        <ImageSubmission />
      </ProtectedRoute>
    ),
  },
  {
    path: `/settings`,
    element: (
      <ProtectedRoute userForbidden={false}>
        <AccountSettings />
      </ProtectedRoute>
    ),
  },
  {
    path: `/calendar`,
    element: (
      <ProtectedRoute userForbidden={false}>
        <Calendar />
      </ProtectedRoute>
    ),
  },
  {
    path: `/editCalendar`,
    element: (
      <ProtectedRoute userForbidden={true}>
        <CalenbdarEditor />
      </ProtectedRoute>
    ),
  },
  {
    path: `/digital-signage`,
    element: <SignageCalendar />,
  },
  {
    path: `/scheduler`,
    element: (
      <ProtectedRoute userForbidden={true}>
        <Scheduler />
      </ProtectedRoute>
    ),
  },
  {
    path: `/groups`,
    element: (
      <ProtectedRoute userForbidden={true}>
        <Groups />
      </ProtectedRoute>
    ),
  },
  {
    path: `/rooms`,
    element: (
      <ProtectedRoute userForbidden={true}>
        <RoomManager />
      </ProtectedRoute>
    ),
  },
  {
    path: `/signage-scheduler`,
    element: <SignageScheduler />,
  },
  {
    path: `/signage`,
    element: (
      <ProtectedRoute userForbidden={true}>
        <SignageEditor />
      </ProtectedRoute>
    ),
  },
  {
    path: `/playlist`,
    element: <SignagePlayList />,
  },

  {
    path: `/testimonials`,
    element: (
      <ProtectedRoute userForbidden={true}>
        <Testimonials />
      </ProtectedRoute>
    ),
  },
  {
    path: `/corporate-menu`,
    element: (
      <ProtectedRoute userForbidden={true} superadminOnly={true}>
        <CorporateMenu />
      </ProtectedRoute>
    ),
  },
  ...facilityRoutes,
];

export default routes;
